import { Link } from 'react-router-dom'
import logo from "/logo2.jpg";


export const Header = () => {
  return (
    <div className='h-[11vh] sticky top-0 z-50 transition-all ease-in-out duration-300'>
    <header className="h-[11vh] w-full bg-[#f4f5f5] shadow-md  flex justify-between items-center" >
    <div className="bg-gray-800 p-0 overflow-hidden">
    <img src={logo} alt="Logo" className="h-[11vh] m-0 " />
    </div>
    
    <div>
    <nav className="flex flex-row gap-4 mx-6 text-lg my-2 items-center justify-end">

      
      
    </nav>
    </div>
  </header>
   <div className="bg-[#233252] text-[#f4f5f5] text-[.9rem] text-center mt-0 py-1">
               
   <p className="font-bold" >Si necesitas soporte, puedes comunicarte al siguiente correo electrónico: transito@monterrey.gob.mx</p>
                  </div>
                  </div>
  )
}
